"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDead = exports.update = exports.updateAll = exports.killAll = exports.kill = exports.create = exports.createMultiple = exports.getAll = void 0;
var spritesSplatters_1 = require("@dive/spriteRecyclers/spritesSplatters");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var diveEnums_1 = require("@dive/enums/diveEnums");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_1 = require("@main/common");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function createMultiple(type, numParticles, i, j, x, y, tint) {
    var rnd = diveSimulationManager_sidecar_1.diveSimulationManager.getSyncedUnimportantRando();
    for (var iParticle = 0; iParticle < numParticles; iParticle++) {
        create(0, type, i, j, Math.round(x + rnd.i(-6, 6)), Math.round(y + rnd.i(-6, 6)), tint); //, color)
    }
}
exports.createMultiple = createMultiple;
function create(id, type, i, j, x, y, tint) {
    if (type === diveEnums_1.EDiveSplatterType.None) {
        assert_sidecar_1.assert.failed('type cannot be None');
    }
    // image.tint = color
    var rnd = diveSimulationManager_sidecar_1.diveSimulationManager.getSyncedUnimportantRando();
    id = common_1.createId(id);
    var splatterIdx = 0;
    if (type === diveEnums_1.EDiveSplatterType.Blood) {
        splatterIdx = rnd.i(0, 2);
    }
    else if (type === diveEnums_1.EDiveSplatterType.Bone) {
        splatterIdx = 3;
    }
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        i: i,
        j: j,
        x: x,
        y: y,
        splatterIdx: splatterIdx,
        flipX: rnd.b(),
        flipY: rnd.b(),
        tint: tint,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
var frames = [
    sprites_sidecar_1.sprites.diveEffectsCloud1[0],
    sprites_sidecar_1.sprites.diveEffectsCloud2[0],
    sprites_sidecar_1.sprites.diveEffectsCloud3[0],
    sprites_sidecar_1.sprites.diveEffectsBone[0],
];
function update(obj) {
    if (obj.isDead) {
        return;
    }
    var visibility = diveTilemapUtils_sidecar_1.diveTilemapUtils.getSpotVisiblityIIJ(obj);
    if (visibility === 0) {
        return;
    }
    var alpha = 1;
    if (visibility === 1) {
        alpha = 0.5;
    }
    var s = spritesSplatters_1.spritesSplatters.getNext(obj.x, obj.y, frames[obj.splatterIdx % frames.length]);
    if (obj.flipX) {
        s.scaleX = -s.scaleX;
    }
    if (obj.flipY) {
        s.scaleY = -s.scaleY;
    }
    s.alpha = alpha;
    s.tint = obj.tint;
}
exports.update = update;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) { });
}
exports.removeDead = removeDead;
